import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportTable from "../../Components/ReportTable/ReportTable";
import useTitle from "../../hooks/useTitle";
import asyncCurrentUser from "../../store/thunks/user/asyncCurrentUser";
import './Employees.scss';

export default function Employees() {
    useTitle("Сотрудникам");

    const authStore = useSelector(store => store.auth);
    const user = useSelector(store => store.user.name)
    const dispatch = useDispatch();

    useEffect(() => {
        const {isAuth} = authStore;
        isAuth && dispatch(asyncCurrentUser());
    }, [authStore]);

    return (
        <main className="employess-page">
            <div className="_container">
                <h2 className="title">Сотрудникам</h2>
                <div className="employee-title">
                    <h3 className="bold">Сотрудник:</h3>
                    <p>{user}</p>
                </div>
                <h3 className="bold">Расчётные листки</h3>
                <ReportTable />
            </div>
        </main>
    )
}